import {
  HStack,
  Box,
  Button as B,
  SimpleGrid,
  useBreakpointValue,
  WrapItem,
  Wrap,
  Text,
  Divider,
} from "@chakra-ui/react";
import { PaymentButton } from "../components/PaymentButton";

const IDRPaymentMethods = ({
  enabledPayments: {
    isQRISEnabled,
    isGopayEnabled,
    isDanaEnabled,
    isLinkAjaEnabled,
    isOvoEnabled,
    isBCAVAEnabled,
    isBNIVAEnabled,
    isBRIVAEnabled,
    isMandiriVAEnabled,
    isPermataVAEnabled,
    isBJBVAEnabled,
    isBSIVAEnabled,
    isCIMBVAEnabled,
  },
  disabledPayments = {},
  allowPayment,
  donate,
  isSubmitting,
}) => {
  const isDesktop = useBreakpointValue([false, false, true]);
  const desktopVaItemWidth = "calc((100% - (4 * 0.5em)) / 5)";
  return (
    <>
      <Wrap columns={5} spacing={"0.5em"} w="100%">
        <PaymentButton
          backgroundColor={"saweria-yellow.normal"}
          disabled={!allowPayment || !!disabledPayments.qris}
          enabled={isQRISEnabled}
          data-testid={"qris-button"}
          loading={isSubmitting}
          type="qris"
          onClick={donate("qris")}
        />

        <PaymentButton
          disabled={!allowPayment || !!disabledPayments.gopay}
          enabled={isGopayEnabled}
          data-testid={"gopay-button"}
          loading={isSubmitting}
          type="gopay"
          onClick={donate("gopay")}
        />
        <PaymentButton
          backgroundColor={"#4d3394"}
          disabled={!allowPayment || !!disabledPayments.ovo}
          enabled={isOvoEnabled}
          data-testid={"ovo-button"}
          loading={isSubmitting}
          type="ovo"
          onClick={donate("ovo")}
        />

        <PaymentButton
          disabled={!allowPayment || !!disabledPayments.dana}
          backgroundColor={"#0c87e1"}
          enabled={isDanaEnabled}
          data-testid={"dana-button"}
          loading={isSubmitting}
          type="dana"
          onClick={donate("dana")}
        />
        <PaymentButton
          backgroundColor={"#e12428"}
          disabled={!allowPayment || !!disabledPayments.linkaja}
          enabled={isLinkAjaEnabled}
          data-testid={"linkaja-button"}
          loading={isSubmitting}
          type="linkaja"
          onClick={donate("linkaja")}
        />
      </Wrap>
      <Divider my={3} borderColor="gray.300" />
      <Text fontWeight="semibold" fontSize="sm" color="gray.600" mb={2}>
        Virtual Account
      </Text>
      {isDesktop ? (
        <Wrap columns={5} spacing={"0.5em"} w="100%">
          <PaymentButton
            backgroundColor={"#DCEEFF"}
            disabled={!allowPayment || !!disabledPayments.bca}
            enabled={isBCAVAEnabled}
          data-testid={"bca-va-button"}
          loading={isSubmitting}
          type="bca"
          onClick={donate("bca")}
        />

        <PaymentButton
          backgroundColor={"#C6F6D5"}
          disabled={!allowPayment || !!disabledPayments.mandiri}
          enabled={isMandiriVAEnabled}
          data-testid={"mandiri-va-button"}
          loading={isSubmitting}
          type="mandiri"
          onClick={donate("mandiri")}
        />
        <PaymentButton
          backgroundColor={"#FFE1AB"}
          disabled={!allowPayment || !!disabledPayments.bri}
          enabled={isBRIVAEnabled}
          data-testid={"bri-va-button"}
          loading={isSubmitting}
          type="bri"
          onClick={donate("bri")}
        />

        <PaymentButton
          backgroundColor={"#FFDCDC"}
          disabled={!allowPayment || !!disabledPayments.bni}
          enabled={isBNIVAEnabled}
          data-testid={"bni-va-button"}
          loading={isSubmitting}
          type="bni"
          onClick={donate("bni")}
        />
        <PaymentButton
          backgroundColor={"#B2E0E6"}
          disabled={!allowPayment || !!disabledPayments.permata}
          enabled={isPermataVAEnabled}
          data-testid={"permata-va-button"}
          loading={isSubmitting}
          type="permata"
          onClick={donate("permata")}
        />

        {isBJBVAEnabled && (
          <WrapItem
            w={isDesktop ? desktopVaItemWidth : "100%"}
            flex={isDesktop ? "0 0 auto" : undefined}
          >
            <PaymentButton
              backgroundColor={"#D6E8FF"}
              disabled={!allowPayment || !!disabledPayments.bjb}
              enabled={isBJBVAEnabled}
              data-testid={"bjb-va-button"}
              loading={isSubmitting}
              type="bjb"
              onClick={donate("bjb")}
            />
          </WrapItem>
        )}

        {isBSIVAEnabled && (
           <WrapItem
            w={isDesktop ? desktopVaItemWidth : "100%"}
              flex={isDesktop ? "0 0 auto" : undefined}
            >
              <PaymentButton
                backgroundColor={"#CFF5DE"}
                disabled={!allowPayment || !!disabledPayments.bsi}
                enabled={isBSIVAEnabled}
                data-testid={"bsi-va-button"}
                loading={isSubmitting}
                type="bsi"
                onClick={donate("bsi")}
              />
            </WrapItem>
        )}

        {isCIMBVAEnabled && (
          <WrapItem
            w={isDesktop ? desktopVaItemWidth : "100%"}
            flex={isDesktop ? "0 0 auto" : undefined}
          >
            <PaymentButton
              backgroundColor={"#FFD6D6"}
              disabled={!allowPayment || !!disabledPayments.cimb}
              enabled={isCIMBVAEnabled}
              data-testid={"cimb-va-button"}
              loading={isSubmitting}
              type="cimb"
              onClick={donate("cimb")}
            />
          </WrapItem>
        )}
      </Wrap>
      ) : (

        <Wrap columns={5} spacing={"0.5em"} w="100%">
          <PaymentButton
            backgroundColor={"#DCEEFF"}
            disabled={!allowPayment || !!disabledPayments.bca}
            enabled={isBCAVAEnabled}
          data-testid={"bca-va-button"}
          loading={isSubmitting}
          type="bca"
          onClick={donate("bca")}
        />

        <PaymentButton
          backgroundColor={"#C6F6D5"}
          disabled={!allowPayment || !!disabledPayments.mandiri}
          enabled={isMandiriVAEnabled}
          data-testid={"mandiri-va-button"}
          loading={isSubmitting}
          type="mandiri"
          onClick={donate("mandiri")}
        />
        <PaymentButton
          backgroundColor={"#FFE1AB"}
          disabled={!allowPayment || !!disabledPayments.bri}
          enabled={isBRIVAEnabled}
          data-testid={"bri-va-button"}
          loading={isSubmitting}
          type="bri"
          onClick={donate("bri")}
        />

        <PaymentButton
          backgroundColor={"#FFDCDC"}
          disabled={!allowPayment || !!disabledPayments.bni}
          enabled={isBNIVAEnabled}
          data-testid={"bni-va-button"}
          loading={isSubmitting}
          type="bni"
          onClick={donate("bni")}
        />
        <PaymentButton
          backgroundColor={"#B2E0E6"}
          disabled={!allowPayment || !!disabledPayments.permata}
          enabled={isPermataVAEnabled}
          data-testid={"permata-va-button"}
          loading={isSubmitting}
          type="permata"
          onClick={donate("permata")}
        />
        <PaymentButton
          backgroundColor={"#D6E8FF"}
          disabled={!allowPayment || !!disabledPayments.permata}
          enabled={isBJBVAEnabled}
          data-testid={"bjb-va-button"}
          loading={isSubmitting}
          type="bjb"
          onClick={donate("bjb")}
        />
        <PaymentButton
          backgroundColor={"#CFF5DE"}
          disabled={!allowPayment || !!disabledPayments.permata}
          enabled={isBSIVAEnabled}
          data-testid={"bsi-va-button"}
          loading={isSubmitting}
          type="bsi"
          onClick={donate("bsi")}
        />
        <PaymentButton
          backgroundColor={"#FFD6D6"}
          disabled={!allowPayment || !!disabledPayments.permata}
          enabled={isCIMBVAEnabled}
          data-testid={"cimb-va-button"}
          loading={isSubmitting}
          type="cimb"
          onClick={donate("cimb")}
        />
      </Wrap>
      )}
    </>
  );
};



const PHPPaymentMethods = ({
  enabledPayments: {
    isGrabPayEnabled = true,
    isGcashEnabled = true,
    isPaymayaEnabled = true,
    isShopeePayEnabled = true,
  },
  disabledPayments = {},
  allowPayment,
  donate,
  isSubmitting,
}) => {
  return (
    <SimpleGrid columns={4} spacing={["0.5em", "2em"]} w="100%">
      <PaymentButton
        disabled={!allowPayment || !!disabledPayments.shopeepay}
        enabled={isShopeePayEnabled}
        data-testid={"shopee-button"}
        loading={isSubmitting}
        type="shopeepay"
        backgroundColor="saweria-pink.normal"
        onClick={donate("shopeepay")}
      />
      <PaymentButton
        disabled={!allowPayment || !!disabledPayments.grabpay}
        enabled={isGrabPayEnabled}
        data-testid={"grabpay-button"}
        loading={isSubmitting}
        type="grabpay"
        backgroundColor="saweria-green.normal"
        onClick={donate("grabpay")}
      />
      <PaymentButton
        disabled={!allowPayment || !!disabledPayments.gcash}
        enabled={isGcashEnabled}
        data-testid={"gcash-button"}
        loading={isSubmitting}
        type="gcash"
        backgroundColor="saweria-green.normal"
        onClick={donate("gcash")}
      />
      <PaymentButton
        disabled={!allowPayment || !!disabledPayments.paymaya}
        enabled={isPaymayaEnabled}
        data-testid={"paymaya-button"}
        loading={isSubmitting}
        type="paymaya"
        backgroundColor="saweria-pink.normal"
        onClick={donate("paymaya")}
      />
    </SimpleGrid>
  );
};

const JPYPaymentMethods = ({
  enabledPayments: {
    isPayPayEnabled = true,
    isAlipayEnabled = true,
    isLinePayEnabled = true,
    isRakutenPayEnabled = true,
    isMerpayEnabled = true,
    isInter_ccEnabled = true,
    isWechat_payEnabled = false,
  },
  disabledPayments = {},
  allowPayment,
  donate,
  isSubmitting,
}) => {
  return (
    <SimpleGrid columns={5} spacing={["0.5em", "2em"]} w="100%">
      <PaymentButton
        disabled={!allowPayment || !!disabledPayments.paypay}
        enabled={isPayPayEnabled}
        data-testid={"paypay-button"}
        loading={isSubmitting}
        type="paypay"
        backgroundColor="saweria-green.normal"
        onClick={donate("paypay")}
      />
      <PaymentButton
        disabled={!allowPayment || !!disabledPayments.alipay}
        enabled={isAlipayEnabled}
        data-testid={"alipay-button"}
        loading={isSubmitting}
        type="alipay"
        backgroundColor="saweria-green.normal"
        onClick={donate("alipay")}
      />
      <PaymentButton
        disabled={!allowPayment || !!disabledPayments.linepay}
        enabled={isLinePayEnabled}
        data-testid={"linepay-button"}
        loading={isSubmitting}
        type="linepay"
        backgroundColor="saweria-green.normal"
        onClick={donate("linepay")}
      />
      <PaymentButton
        disabled={!allowPayment || !!disabledPayments.rakutenpay}
        enabled={isRakutenPayEnabled}
        data-testid={"rakuten-button"}
        loading={isSubmitting}
        type="rakutenpay"
        backgroundColor="saweria-green.normal"
        onClick={donate("rakutenpay")}
      />
      <PaymentButton
        disabled={!allowPayment || !!disabledPayments.merpay}
        enabled={isMerpayEnabled}
        data-testid={"merpay-button"}
        loading={isSubmitting}
        type="merpay"
        backgroundColor="saweria-green.normal"
        onClick={donate("merpay")}
      />
      <PaymentButton
        disabled={!allowPayment || !!disabledPayments.inter_cc}
        enabled={isInter_ccEnabled}
        data-testid={"inter_cc-button"}
        loading={isSubmitting}
        type="inter_cc"
        backgroundColor="saweria-green.normal"
        onClick={donate("inter_cc")}
      />
      <PaymentButton
        disabled={!allowPayment || !!disabledPayments.wechat_pay}
        enabled={isWechat_payEnabled}
        data-testid={"wechat_pay-button"}
        loading={isSubmitting}
        type="wechat_pay"
        backgroundColor="saweria-green.normal"
        onClick={donate("wechat_pay")}
      />
    </SimpleGrid>
  );
};

const PaymentMethods = ({
  allowPayment,
  isSubmitting,
  donate,
  currency = "IDR",
  enabledPayments,
  disabledPayments = {},
}) => {
  const propsToPass = {
    allowPayment,
    donate,
    isSubmitting,
    enabledPayments,
    disabledPayments,
  };
  switch (currency) {
    case "IDR":
      return <IDRPaymentMethods {...propsToPass} />;
    case "PHP":
      return <PHPPaymentMethods {...propsToPass} />;
    case "JPY":
      return <JPYPaymentMethods {...propsToPass} />;
    default:
      return null;
  }
};

export { PaymentMethods };
